import React from "react";
import { boardName } from "./medtrackBoard";
import { PurposeBadge } from "./purposeBadge";

/*
 * The lists OSA's board shows under its room grid (7825 only, from
 * profile.medtrack): one per status panel ("RT" = visits in "Ready for
 * Frances") and the Pay-in-Cash list. Each entry: marker, "Last, F", patient
 * id, provider short name and the visit purpose (OSA's coloured badge when
 * the profile has purposeBadges; surname letters from surnameLetters).
 */
const OsaBoardList = ({ title, rows, marker, markerClass, providerName, purposeBadges, surnameLetters }) => (
  <div className="bg-white rounded-xl shadow-sm p-3 mt-2" data-testid={`medtrack-list-${title}`}>
    <div className="flex items-center justify-between mb-2">
      <h6 className="text-base font-bold text-gray-800 uppercase tracking-wide">{title}</h6>
      <span className={`${markerClass} text-white text-xs font-bold px-2 py-0.5 rounded-full`}>{rows.length}</span>
    </div>
    {rows.length === 0 ? (
      <p className="text-gray-400 text-sm text-center py-3">No data available</p>
    ) : (
      <div className="grid grid-cols-2 gap-1.5">
        {rows.map((patient, index) => (
          <div
            key={`${title}-${patient.id ?? patient.patientid}-${index}`}
            className="flex gap-2 rounded-lg px-2 py-1.5 border border-black justify-between"
          >
            <div className="flex items-center gap-2 min-w-0">
              <div className={`w-6 h-6 rounded-full ${markerClass} text-white text-xs font-bold flex items-center justify-center flex-shrink-0`}>
                {marker === "index" ? index + 1 : marker}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-bold text-gray-800 leading-tight truncate">
                  {boardName(patient, surnameLetters)}
                  <span className="text-sm text-orange-500 font-semibold px-2">{patient.patientid}</span>
                </p>
                <p className="text-sm font-semibold m-0">{providerName(patient?.linked_provider || "")}</p>
              </div>
            </div>
            {patient.purpose && purposeBadges ? (
              <div className="flex-shrink-0 self-center">
                <PurposeBadge purpose={patient.purpose} />
              </div>
            ) : patient.purpose ? (
              <div className="flex-shrink-0 self-center border border-black rounded-2xl px-2 py-0.5 text-xs font-medium">
                {patient.purpose}
              </div>
            ) : null}
          </div>
        ))}
      </div>
    )}
  </div>
);

const OsaBoardLists = ({ boardProfile, statusPanelPatients, payInCashPatients, providerName }) => (
  <>
    {(boardProfile.statusPanels || []).map(({ status, title }) => (
      <OsaBoardList
        key={status}
        title={title || status}
        rows={statusPanelPatients[status] || []}
        marker="index"
        markerClass="bg-purple-500"
        providerName={providerName}
        purposeBadges={Boolean(boardProfile.purposeBadges)}
        surnameLetters={boardProfile.surnameLetters}
      />
    ))}
    {boardProfile.payInCash ? (
      <OsaBoardList
        title="Pay-in-Cash"
        rows={payInCashPatients}
        marker="$"
        markerClass="bg-green-500"
        providerName={providerName}
        purposeBadges={Boolean(boardProfile.purposeBadges)}
        surnameLetters={boardProfile.surnameLetters}
      />
    ) : null}
  </>
);

export default OsaBoardLists;
